import { OvivioLogoComponent } from 'src/components/shared/ovivio-logo/ovivio-logo.component';
import { createThemeFromBase } from './ovivio-base.theme';

/**
 * DoenKids Theme Configuration
 *
 * Uses the same design system as Ovivio (colors, fonts, UI patterns).
 * Only difference is the logoTitle is set to 'Doenkids'.
 */
export const doenkidsTheme = createThemeFromBase({
  id: 'doenkids',
  name: 'DoenKids',
  brandName: 'DoenKids',

  domains: ['doenkids.nl', 'localhost:4200', 'doenkids-admin-test.firebaseapp'],

  colors: {
    primary: {
      main: '#7F53F9',
      light: '#F2E6FE',
      medium: '#CEB5FC',
      dark: '#5D3DB7',
      contrast: '#ffffff',
    },

    secondary: {
      main: '#0D8CED',
      light: '#E5F2FF',
      medium: '#B3DDFF',
      dark: '#0A6AB8',
      contrast: '#ffffff',
    },

    warn: {
      main: '#FA5329',
      light: '#FBF3EF',
      medium: '#FDC8B4',
      dark: '#C8421F',
      contrast: '#ffffff',
    },

    warning: '#FA5329',
    purple: '#7F53F9',

    alert: '#FA5329',
    alertLight: '#FDC8B4',

    bso: '#7F53F9',
    kdv: '#0D8CED',
  },

  assets: {
    logo: './assets/images/logo-ovivio.png',
    favicon: 'assets/favicons/favicon-ovivio.ico',
    logoComponent: OvivioLogoComponent,
    logoTitle: 'DoenKids',
    poweredByLogo: '',
    sidebarBackground: 'none',
    avatarBackground: './assets/images/ovivio-avatar-bg.png',
    avatarImg: './assets/images/avatar-ovivio.svg',
    activityPlaceholder: './assets/images/activities/activity-placeholder.png',
    activityBlockedImage: './assets/images/activities/activity-blocked.png',
    activity404Image: './assets/images/activities/activity-404.jpg',
  },

  icons: {
    activities: 'ovivio-notebook',
    baseActivities: 'ovivio-notebook',
    examples: 'ovivio-book-open',
    baseExamples: 'ovivio-book-open',
    calendar: 'ovivio-calendar',
    pinboard: 'ovivio-push-pin',
    organizationUsers: 'ovivio-user-square',
    organizationDetails: 'ovivio-building',
    settings: 'ovivio-gear',
    activeUsers: 'ovivio-user-check',
    insights: 'ovivio-footprints',
    newsItems: 'ovivio-newspaper',
    baseNewsItems: 'ovivio-newspaper',
    reviews: 'ovivio-sidebar',
  },

  auth0: {
    logoUrl: './assets/images/logo-ovivio.png',
    themeColor: '#7F53F9',
  },
});
